import dayjs from 'dayjs'
import {range} from 'lodash'

export const weekdays = range(0, 7).map((day) =>
  dayjs().set('day', day).toDate().toLocaleString(undefined, {weekday: 'long'}),
)
